
<template>
    <v-main>
        <v-container fluid>  
            <v-card flat>
                <v-row cols="12">
                    <v-col cols="1">
                    </v-col>
                    <v-col cols="10" ><v-card-title class="justify-center">{{this.title}}</v-card-title></v-col>
                    <v-col cols="1" v-if="prip_can_create">
                        <v-spacer/>
                        <btn_plus ref="btn_plus" data="createAction" @actionClick="newPrip" tooltip="Add price improvement" :size="20"/>
                    </v-col>
                </v-row>
                <v-divider class="mb-2"/>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Opt-in / Opt-out</th>
                            <th>Description</th>
                            <th>wijzig tm datum</th>
                            <th>Mail datum</th>
                            <th>Response</th>
                            <th>MyVilla Texts</th>
                            <th>Accommodaties</th>
                            <th>E-mail Templates</th>
                            <th>E-mailings</th>
                            <th v-if="prip_can_create">Edit</th>
                            <th v-if="prip_can_create">Copy</th>
                            <th v-if="prip_can_create">Delete</th>
                        </tr>
                    </thead>
                    <tbody v-for="(pripRecord, i) in searchPrip" :key="i">
                        <tr :class="{'color': i%2!==0}">
                            <td>{{ pripRecord.prip_nr }}</td>
                            <td>{{ pripRecord.prip_opt_in_out }}</td>
                            <td>{{ pripRecord.prip_oms }}</td>
                            <td>{{ pripRecord.prip_wijzig_tot_dat }}</td>
                            <td>{{ pripRecord.prip_mail_dt }}</td>
                            <td>
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="viewPrip(pripRecord.prip_nr)">
                                                <v-icon>mdi-list-status</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Response overview</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="$router.open('/syst/prip/searchPripTaal/' + pripRecord.prip_nr)">
                                                <v-icon>mdi-file-document-edit-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit myVilla texts</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="addAcco(pripRecord.prip_nr)">
                                                <v-icon>mdi-home-plus-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit accommodations</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td>
                                <span v-for="item in pripRecord.mltps" :key=item.mltp_nr>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="$router.open('/syst/mltp/onMltp/' + item.mltp_encrid)">
                                                <v-icon>mdi-file-document-edit-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit template {{ item.mltp_nr }}</span>
                                    </v-tooltip>
                                </span>
                            </td>
                            <td>
                                <span v-for="item in pripRecord.mltps" :key=item.mltp_nr>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="sendMail(pripRecord.prip_nr, item.mltp_nr)">
                                                <v-icon>mdi-email-fast-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span v-if="pripRecord.prip_nr === item.mltp_nr">Send email {{ item.mltp_nr }}</span>
                                        <span v-else>Send email {{ item.mltp_nr }}</span>
                                    </v-tooltip>
                                </span>
                            </td>
                            <td v-if="prip_can_create">
                                <div v-if="pripRecord.prip_can_edit">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="editPrip(pripRecord.prip_nr)">
                                                <v-icon>mdi-pencil-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit price improvement</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td v-if="prip_can_create">
                                <div v-if="pripRecord.prip_can_copy">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="copyPrip(pripRecord.prip_nr)">
                                                <v-icon>mdi-content-copy</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Copy price improvement</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td v-if="prip_can_create">
                                <div v-if="pripRecord.prip_can_delete">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="deletePrip(pripRecord.prip_nr)">
                                                <v-icon>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete price improvement</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>  
                </v-simple-table>  
            </v-card>  
        </v-container>
        <navBar title="Ares - Various" :home="true" type="various"/>   
        <newPrip ref="newPrip" @reload="getData"/>
        <viewPrip ref="viewPrip" />
        <addPripAcco ref="addPripAcco" @reload="getData"/>
        <sendPripMail ref="sendPripMail" @reload="getData"/>
        <confirm_dialog ref="confirm" @confirm="removePrip"/>
    </v-main>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue"
    import btn_plus from "@/components/ui/buttons/btn_plus.vue";
    import newPrip from "@/views/syst/prip/newPrip.vue";
    import viewPrip from "@/views/syst/prip/viewPrip.vue";
    import addPripAcco from "@/views/syst/prip/addPripAcco.vue";
    import sendPripMail from "@/views/syst/prip/sendPripMail.vue";
    import confirm_dialog from "@/components/ui/confirm_dialog.vue";
    export default {
        components: {
            navBar,
            btn_plus,
            newPrip,
            viewPrip,
            addPripAcco,
            sendPripMail,
            confirm_dialog
        },
        data() {
            return {
                searchPrip: [],
                title: "Price improvements overview",
                prip_can_create: false
            }  
        },
        mounted() { 
            this.getData();
        },
        methods: {
            getData() {
                this.$axios.post("ares/json/ares/syst/prip/searchPrip.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchPrip"
                    },
                    searchPrip: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.prip_can_create = res.data.prip_can_create;
                        this.searchPrip = res.data.searchPrip;
                    }
                });
            },
            newPrip() {
                this.$refs.newPrip.openNewPrip(0, true)
            },
            editPrip(nr) {
                this.$refs.newPrip.openNewPrip(nr, false)
            },
            copyPrip(nr) {
                this.$refs.newPrip.openNewPrip(nr, true)
            },
            viewPrip(nr) {
                this.$refs.viewPrip.openViewPrip(nr)
            },
            addAcco(nr) {
                this.$refs.addPripAcco.getPripAcco(nr)
            },
            sendMail(nr, mltp_nr) {
                this.$refs.sendPripMail.sendPripMail(nr, mltp_nr)
            },
            deletePrip(nr) {
                this.$refs.confirm.open({
                    title: "Remove price improvement " + nr,
                    message: "This will remove all data, texts & tempates",
                    type: nr,
                    cancel: "Cancel",
                    confirm: "Confirm"
                })
            },
            removePrip(nr) {
                this.$axios.post("ares/json/ares/syst/prip/removePrip.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "removePrip"
                    },
                    removePrip: {
                        prip_nr: nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.removePrip.text,
                            color: res.data.removePrip.color
                        });
                        if (res.data.removePrip.color === "success") {
                            this.getData()
                        }
                    }
                });
            },
        }
    };
</script> 


<style scoped>
  .color {
    background-color: #faf8f8;
  }
</style>